"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.french = void 0;
var types_1 = require("../types");
exports.french = {
    code: types_1.LocaleCode.French,
    facebook: 'fr_FR',
    label: 'Français',
    loadingText: 'Chargement...',
    translations: {
        ar: 'Arabe',
        de: 'Allemand',
        en: 'Anglais',
        es: 'Espagnol',
        fr: 'Français',
        id: 'Indonésienne',
        it: 'Italien',
        ja: 'Japonais',
        ko: 'Coréen',
        lo: 'Lao',
        ms: 'Malaise',
        pt: 'Portugaise',
        ru: 'Russe',
        th: 'Thai',
        tl: 'Philippine',
        tr: 'Turque',
        vi: 'Vietnamienne',
        'zh-CN': 'Chinois (Simp.)',
        'zh-TW': 'Chinois (Trad.)'
    }
};
